<template>
  <div id="app">
    <nav>
      <router-link to="/ChordDict">Chord Dict</router-link> |
      <router-link to="/ChordTyper">Chord Typer</router-link>
    </nav>
    <router-view></router-view>
  </div>
</template>
